import { AwsRum, AwsRumConfig } from "aws-rum-web";
let awsRum: AwsRum | null = null;

try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1.0,
    identityPoolId: process.env.RUM_IDENTITY_POOL_ID,
    endpoint: process.env.RUM_ENDPOINT,
    telemetries: ["http", "errors", "performance"],
    allowCookies: true,
    enableXRay: true,
    signing: true,
    guestRoleArn: process.env.RUM_GUEST_ROLE_ARN,
  };
  const APPLICATION_ID: string = process.env.RUM_APPLICATION_ID!;
  const APPLICATION_VERSION: string = process.env.RUM_APPLICATION_VERSION!;
  const APPLICATION_REGION: string = process.env.RUM_APPLICATION_REGION!;
  awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config,
  );
} catch (error) {
  console.error("AWS RUM initialization failed:", error);
}

export { awsRum };
